import InputComponent from "V2.0/components/InputComponent";

export function DaysToCheckSlotsFor(props) {
  const { daysToCheckSlotsFor, updateDaysToCheckSlotFor, disabled } = props;

  return (
    <div className="grid grid-cols-3">
      <div className="col-span-3 xl:col-span-2 ml-4">
        <InputComponent
          type="number"
          label="Availability Window"
          description="Number of days to check for available slots."
          min="2"
          max="7"
          value={daysToCheckSlotsFor}
          onChange={(e) => {
            updateDaysToCheckSlotFor(Number(e.target.value));
          }}
          disabled={disabled}
        />
      </div>
    </div>
  );
}
